import gsap from 'gsap/dist/gsap'
// import { MotionPathHelper } from 'gsap/dist/MotionPathHelper'
import { useLayoutEffect, useRef } from 'react'
import { useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

import { GEM_TYPE } from '~/components/QuestPanel/type'
import { GemType } from '~/components/Rock/types'

import StrokeText from './StrokeText'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '40px' }]

const AnimationGems = ({ gemType, noOfGems }: { gemType: GemType; noOfGems: number }): React.ReactElement => {
  const gemsRef = useRef(null)
  const gemsAmount = useRef(gemType === GEM_TYPE.RED ? noOfGems : noOfGems * 10)
  const isMobile = useCheckBreakpoint({ lt: Breakpoint.MD })
  const { t } = useTranslation('bootcamp')

  // console.log(gemsAmount.current)
  // Shorter path for mobile since chest is small
  const animationPath = isMobile
    ? 'M19.351,15.046 C21.537,-32.797 -4.862,-53.582 -38.01,-47.729'
    : 'M19.351,15.046 C21.537,-32.797 -35.831,-57.358 -68.959,-51.501'

  useLayoutEffect(() => {
    gsap.set(gemsRef.current, { xPercent: -50, yPercent: -50, transformOrigin: '50% 50%' })
    gsap.to(gemsRef.current, {
      duration: 1,
      motionPath: {
        path: animationPath,
      },
    })

    gsap.to(gemsRef.current, {
      duration: 2,
      delay: 2.2,
      opacity: 0,
    })

    // MotionPathHelper.create(gemsRef.current)
  }, [animationPath])

  return (
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10" ref={gemsRef}>
      <StrokeText className="absolute -left-8 top-0 z-20 leading-10" fontSize={isMobile ? 20 : 30}>
        +{gemsAmount.current}
      </StrokeText>
      <ResponsiveImage
        alt={`${t('gems')} ${gemType}`}
        fit="contain"
        height={40}
        imageWidths="40"
        mediaQuery={mediaQuery}
        srcKey="icons/gem-icon.png"
        width={40}
      />
    </div>
  )
}

export default AnimationGems
